import React from 'react';

interface OverviewItem {
  label: string;
  value: string | number;
  color?: string;
  icon?: React.ReactNode;
}

interface OverviewBarProps {
  items: OverviewItem[];
  loading?: boolean;
}

export default function OverviewBar({ items, loading }: OverviewBarProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-5">
      {items.map((item) => (
        <div key={item.label} className="card p-3.5 flex flex-col gap-1">
          <div className="flex items-center justify-between">
            <p className="text-xs text-gray-500 font-medium leading-none">{item.label}</p>
            {item.icon && <span className="text-gray-400">{item.icon}</span>}
          </div>
          {loading ? (
            <div className="h-6 w-16 bg-gray-200 rounded animate-pulse mt-1" />
          ) : (
            <p className={`text-xl font-bold mt-0.5 ${item.color || 'text-gray-900'}`}>{item.value}</p>
          )}
        </div>
      ))}
    </div>
  );
}
